import React from 'react'
import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import { ArrowUp, ArrowDown, CaretRight } from '@phosphor-icons/react'
export interface DashboardPendingItem {
  id: string
  group_id: string
  [key: string]: any
}

interface PendingTransactionsWidgetProps {
  pendingApprovals: DashboardPendingItem[]
  pendingSent: DashboardPendingItem[]
}

export function PendingTransactionsWidget({ pendingApprovals, pendingSent }: PendingTransactionsWidgetProps) {
  const navigate = useNavigate()

  if (pendingApprovals.length === 0 && pendingSent.length === 0) {
    return null
  }

  return (
    <section>
      <div className="flex items-center justify-between mb-4 px-1">
        <h3 className="text-[15px] font-bold uppercase tracking-[0.18em] text-espresso/80">
          Bekleyen İşlemler
        </h3>
      </div>
      <div className="flex flex-col gap-2">
        {/* Alıcısı olduğunuz — sadece > 0 ise göster */}
        {pendingApprovals.length > 0 && (
          <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-white border rounded-2xl py-3 px-4 flex items-center justify-between shadow-[0_2px_12px_rgba(0,0,0,0.04)] transition-shadow border-emerald-100 cursor-pointer hover:shadow-md"
            onClick={() => navigate(`/groups/active?id=${pendingApprovals[0].group_id}&openReceiver=true`)}
          >
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-xl bg-emerald-50 border border-emerald-100 flex items-center justify-center">
                <ArrowDown size={16} weight="bold" className="text-emerald-600" />
              </div>
              <span className="text-[13px] font-semibold text-espresso">Alıcısı Olduğunuz</span>
            </div>
            <div className="flex items-center gap-2.5">
              <div className="text-right">
                <span className="text-[15px] font-black text-espresso leading-none">{pendingApprovals.length}</span>
                <span className="text-[10px] font-medium text-espresso/40 ml-1.5">
                  Onay bekliyor
                </span>
              </div>
              <CaretRight size={14} weight="bold" className="text-slate-300" />
            </div>
          </motion.div>
        )}

        {/* Göndericisi olduğunuz — sadece > 0 ise göster */}
        {pendingSent.length > 0 && (
          <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.05 }}
            className="bg-white border rounded-2xl py-3 px-4 flex items-center justify-between shadow-[0_2px_12px_rgba(0,0,0,0.04)] transition-shadow border-slate-200 cursor-pointer hover:shadow-md"
            onClick={() => navigate(`/groups/active?id=${pendingSent[0].group_id}`)}
          >
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-xl bg-slate-50 border border-slate-200 flex items-center justify-center">
                <ArrowUp size={16} weight="bold" className="text-slate-500" />
              </div>
              <span className="text-[13px] font-semibold text-espresso">Göndericisi Olduğunuz</span>
            </div>
            <div className="flex items-center gap-2.5">
              <div className="text-right">
                <span className="text-[15px] font-black text-espresso leading-none">{pendingSent.length}</span>
                <span className="text-[10px] font-medium text-espresso/40 ml-1.5">
                  Yanıt bekliyor
                </span>
              </div>
              <CaretRight size={14} weight="bold" className="text-slate-300" />
            </div>
          </motion.div>
        )}
      </div>
    </section>
  )
}
